import React from 'react';
import { useAlert } from '../context/AlertContext';

const Alert = () => {
  const { alerts } = useAlert();

  if (alerts.length === 0) return null;

  return (
    <div className="toast-container">
      {alerts.map((alert) => (
        <div key={alert.id} className={`toast alert alert-${alert.type}`}>
          {alert.message}
        </div>
      ))}
    </div>
  );
};

export default Alert;
